import { faqs } from '@/mocks/faqs';

export default function FAQSection() {
  return (
    <section className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于膀胱健康的常见疑问，我们为您一一解答
          </p>
        </div>
        <div className="flex flex-col gap-3 md:gap-4">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors list-none">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-500 group-open:hidden">
                  <i className="ri-add-line text-base"></i>
                </div>
                <div className="w-5 h-5 items-center justify-center flex-shrink-0 text-foreground-500 hidden group-open:flex">
                  <i className="ri-subtract-line text-base"></i>
                </div>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-700 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}